
// Landing screen of the AEP renewal wizard (#656, Dien's 2026-08-30 feedback
// round). The what-you-can-change education moved OFF this page to step 2,
// where we actually know the client's coverage -- this page now only sets the
// window, the deadline (directly under the dates, called out), and the
// what-you'll-want-nearby list (so people go get their pill bottles and their
// doctors' names before they start, not mid-wizard). "Back to my account" is
// gone (same round): one primary action, centered.
//
// The lede promises TIME ONLY (2026-09-16). It used to close with "then show
// you what changed and what fits" -- but /renewal is an intake survey, not a
// self-service shopping tool: nothing is shown here, an advisor emails the
// recommendation afterwards (the promise date the done step stamps). Don't
// re-add a results promise to this page.
//
// Years are derived, never hardcoded: `planYear` is the year being shopped FOR
// (the store's `nextYear` getter), so the enrollment window and deadline
// belong to the calendar year before it.
import Callout from '../parts/Callout.vue'

export default {
    components: { Callout },
    props: {
        // The plan year being reviewed, from the store's `nextYear` getter.
        planYear: { type: Number, required: true },
    },
    computed: {
        aepWindow () {
            return `October 15 to December 7, ${this.planYear - 1}`
        },
    },
}
